import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography, InputBase, Grid, Paper } from '@material-ui/core'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import Header from '../../../../layout/Header'
import Subheader from '../../../../layout/Subheader'
import Loading from '../../../../components/Loading'

import { formatDateTimeToRender, formatDateToRender } from '../../../../utils/functions'

import useStyles from './style'

function Render ({
  inputs,
  handleInputChange,
  getAncoras,
  getLoading
}) {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Header />
      <Subheader title="Visualizando taxas faixas: " back={false} subanchor={true}/>
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {getLoading
            ? (<Loading />)
            : (
            <form>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Informações</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>
                <Grid item xs={6}>
                  <label className={classes.label}>Valor Inicial</label>
                  <Paper className={classes.medium} elevation={0}>
                  <InputBase
                    className={classes.input}
                    value={`R$ ${inputs.valorInicial}`}
                    placeholder="Digite o valor inicial"
                    required
                    readOnly
                    inputProps={{ pattern: '[0-9]+([\..][0-9]+)?', title: 'Utilize "." para informar valores' }}
                    name="valorInicial"
                  />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                <label className={classes.label}>Valor Final</label>
                  <Paper className={classes.medium} elevation={0}>

                  <InputBase
                    className={classes.input}
                    value={`R$ ${inputs.valorFinal}`}
                    placeholder="Digite o valor final"
                    required
                    readOnly
                    inputProps={{ pattern: '[0-9]+([\..][0-9]+)?', title: 'Utilize "." para informar valores' }}
                    name="valorFinal"
                  />
                  </Paper>
                </Grid>

                <Grid item xs={6}>
                  <label className={classes.label}>Taxa</label>
                  <Paper className={classes.medium} elevation={0}>
                  <InputBase
                    className={classes.input}
                    value={`${inputs.taxa} %`}
                    placeholder="Digite a taxa"
                    inputProps={{ pattern: '[0-9]+([\..][0-9]+)?', step: '0.01', title: 'Utilize "." para informar valores' }}
                    required
                    readOnly
                    name="taxa"
                  />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                <label className={classes.label}>Rede</label>
                  <Paper className={classes.medium} elevation={0}>
                  <select
                      className={classes.input}
                      required
                      value={inputs.ancoraId}
                      name="ancoraId"
                      disabled
                      onChange={handleInputChange}
                    >
                      <option value="">Selecione uma rede</option>
                      {getAncoras.map(ancora => (
                        <option key={ancora.ancoraId} value={ancora.ancoraId}>{ancora.razaoSocial}</option>
                      ))}
                    </select>
                  </Paper>
                </Grid>

                <Grid item xs={6}>
                  <label className={classes.label}>Status</label>
                  <Paper className={classes.medium} elevation={0}>

                  <select
                      className={classes.input}
                      required
                      disabled
                      value={inputs.status}
                      name="status"
                      onChange={handleInputChange}
                    >
                      <option value="Ativo">Ativo</option>
                      <option value="Inativo">Inativo</option>
                    </select>
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                  <label className={classes.label}>Data Início Cobrança</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataInicioCobranca && formatDateToRender(inputs.dataInicioCobranca)}
                      readOnly
                      placeholder="Data Início Cobrança"
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Data Final Cobrança</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataFinalCobranca && formatDateToRender(inputs.dataFinalCobranca)}
                      readOnly
                      placeholder="Data Final Cobrança"
                    />
                  </Paper>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Dados do Registro</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>

              <Grid item xs={6}>
                  <label className={classes.label}>Data de Registro</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataRegistro && formatDateTimeToRender(inputs.dataRegistro)}
                      readOnly
                      placeholder="Data do Registro"
                    />
                  </Paper>
                </Grid>

                <Grid item xs={6}>
                  <label className={classes.label}>Data da Atualização</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataAtualizacao ? formatDateTimeToRender(inputs.dataAtualizacao) : ''}
                      readOnly
                      placeholder="Data da Atualização"
                    />
                  </Paper>
                </Grid>

              </Grid>
            </AccordionDetails>
            </Accordion>
          </form>
              )}
        </div>

      </div>
    </div>
  )
}

export default Render
